var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.with_margin ? 'm-b-15' : '',attrs:{"dusk":'btn_create_'+_vm.model_name,"block":_vm.block ? true : false,"variant":"primary"},on:{"click":_vm.create}},[_c('i',{staticClass:"icon-plus"}),_vm._v(" Crear ")])
}
var staticRenderFns = []

export { render, staticRenderFns }